<template>
    <div :class="containerClass">
        <div
            v-if="title !== null || badgeText !== null"
            class="flex items-start justify-between gap-3"
        >
            <h3
                v-if="title !== null"
                class="min-w-0 flex-1 text-sm font-bold text-slate-700"
            >
                {{ title }}
            </h3>
            <p
                v-if="badgeText !== null"
                :class="['shrink-0 whitespace-nowrap', badgeClass]"
            >
                {{ badgeText }}
            </p>
        </div>

        <div :class="contentClass">
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
    interface FeaturePageMockPanelProps {
        title?: string | null
        badgeText?: string | null
        containerClass?: string
        badgeClass?: string
        contentClass?: string
    }

    withDefaults(defineProps<FeaturePageMockPanelProps>(), {
        title: null,
        badgeText: null,
        containerClass:
            'rounded-xl border border-slate-200 bg-white p-6 shadow-xs shadow-slate-200/70',
        badgeClass:
            'rounded-full bg-primary-shade-ligth px-3 py-1 text-xs font-bold text-primary-shade',
        contentClass: 'mt-4 space-y-3',
    })
</script>
